// src/app/redux/reducers/cataloguesReducer.js

import {
    SET_CATALOGUES_LOADING,
    SET_CATALOGUES_ERROR,
    RESET_CATALOGUE_STATE,
    FETCH_CATALOGUES_SUCCESS,
    FETCH_CATALOGUES_FAIL,
    CREATE_CATALOGUE_REQUEST,
    CREATE_CATALOGUE_SUCCESS,
    CREATE_CATALOGUE_FAIL,
    UPDATE_CATALOGUE_REQUEST,
    UPDATE_CATALOGUE_SUCCESS,
    UPDATE_CATALOGUE_FAIL,
    DELETE_CATALOGUE_SUCCESS,
    DELETE_CATALOGUE_FAIL,
} from "../actions/cataloguesActions";

const initialState = {
    loading: false,
    error: null,
    success: false,
    catalogues: [],
};

const mergeCatalogue = (catalogues, payload) => {
    const list = Array.isArray(catalogues) ? catalogues : [];

    if (!payload || typeof payload !== "object") {
        return list;
    }

    const payloadId = payload.id;

    if (payloadId === undefined || payloadId === null) {
        return list;
    }

    let found = false;

    const nextList = list.map((catalogue) => {
        if (catalogue?.id !== payloadId) {
            return catalogue;
        }

        found = true;
        return { ...catalogue, ...payload };
    });

    return found ? nextList : list;
};

export default function cataloguesReducer(state = initialState, action) {
    switch (action.type) {
        case SET_CATALOGUES_LOADING:
            return {
                ...state,
                loading: Boolean(action.payload),
                // success: action.payload ? false : state.success,
            };


        case SET_CATALOGUES_ERROR:
            return { ...state, error: action.payload, success: false };

        case RESET_CATALOGUE_STATE:
            return {
                ...state,
                success: false,
                error: null,
            };

        case CREATE_CATALOGUE_REQUEST:
        case UPDATE_CATALOGUE_REQUEST:
            return {
                ...state,
                loading: true,
                success: false,
                error: null,
            };

        case FETCH_CATALOGUES_SUCCESS:
            return {
                ...state,
                loading: false,
                catalogues: Array.isArray(action.payload) ? action.payload : [],
                error: null,
            };

        case CREATE_CATALOGUE_SUCCESS: {
            const nextCatalogue = action.payload;
            const nextList = Array.isArray(state.catalogues) ? [...state.catalogues] : [];

            if (nextCatalogue && typeof nextCatalogue === "object") {
                nextList.push(nextCatalogue);
            }

            return {
                ...state,
                loading: false,
                catalogues: nextList,
                error: null,
                success: true,
            };
        }

        case UPDATE_CATALOGUE_SUCCESS:
            return {
                ...state,
                loading: false,
                catalogues: mergeCatalogue(state.catalogues, action.payload),
                error: null,
                success: true,
            };

        case FETCH_CATALOGUES_FAIL:
        case CREATE_CATALOGUE_FAIL:
        case UPDATE_CATALOGUE_FAIL:
        case DELETE_CATALOGUE_FAIL:
            return { ...state, loading: false, error: action.payload, success: false };

        case DELETE_CATALOGUE_SUCCESS:
            return {
                ...state,
                loading: false,
                catalogues: (Array.isArray(state.catalogues) ? state.catalogues : []).filter((c) => c?.id !== action.payload),
                error: null,
                success: true,
            };

        default:
            return state;
    }
}
